module.exports = __webpack_public_path__ + "static/media/hamburger.439b92e0.svg";